var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcShoppingCartSuperBigCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "#0033AD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 74,
    height: 74,
    rx: 37,
    fill: "url(#paint0_linear)",
    fillOpacity: 0.05
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.918 38.6673C48.168 38.6673 49.268 37.984 49.8346 36.9507L55.8013 26.134C56.418 25.034 55.618 23.6673 54.3513 23.6673H29.6846L28.118 20.334H22.668V23.6673H26.0013L32.0013 36.3173L29.7513 40.384C28.5346 42.6173 30.1346 45.334 32.668 45.334H52.668V42.0007H32.668L34.5013 38.6673H46.918ZM31.268 27.0007H51.518L46.918 35.334H35.218L31.268 27.0007ZM32.668 47.0007C30.8346 47.0007 29.3513 48.5007 29.3513 50.334C29.3513 52.1673 30.8346 53.6673 32.668 53.6673C34.5013 53.6673 36.0013 52.1673 36.0013 50.334C36.0013 48.5007 34.5013 47.0007 32.668 47.0007ZM49.3346 47.0007C47.5013 47.0007 46.018 48.5007 46.018 50.334C46.018 52.1673 47.5013 53.6673 49.3346 53.6673C51.168 53.6673 52.668 52.1673 52.668 50.334C52.668 48.5007 51.168 47.0007 49.3346 47.0007Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 41,
    y1: 0,
    x2: 41,
    y2: 74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcShoppingCartSuperBigCircle);
export default __webpack_public_path__ + "static/media/ic_shopping_cart_super_big_circle.00f3477a3478dd92e018c8b068385f2d.svg";
export { ForwardRef as ReactComponent };